<div class="pt-3 pl-md-4" *ngIf="eventNotFound">
  <h2>Event not found</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="loadingEvent">
  <h2>Loading Event...</h2>
</div>

<div class="pt-3 pl-md-4 mb-6" *ngIf="!loadingEvent && !eventNotFound && (serverError === null)">

  <div class="row">
    <div class="col-12 col-lg-4">
      <a [routerLink]="backUrl">
        &larr; Back to Scheduled Events
      </a>
    </div>
    <div class="col-12 col-lg-4 text-center">
      <h4 class="mb-0">
        {{ event.name }}
        <ng-container *ngIf="event.occurrence_name">
          - {{ event.occurrence_name }}
        </ng-container>
        <ng-container *ngIf="(!event.occurrence_name) && event.customer_facing_name">
          - {{ event.customer_facing_name }}
        </ng-container>
      </h4>
      <b>
        {{ dateStringFromISO8601(event.start_datetime, event.time_zone) }}
        {{ timeStringFromISO8601(event.start_datetime, event.time_zone) }} -
        {{ timeStringFromISO8601(event.end_datetime, event.time_zone) }}
        <ng-container *ngIf="event.event_part_count > 1">
          <br>
          Part {{ event.event_part_number }} of {{ event.event_part_count }}
        </ng-container>
      </b>
    </div>
    <div class="col-12 col-lg-4 text-lg-right mb-2">
      <button class="btn btn-outline-primary btn-sm mr-2"
              (click)="openSetEventPartInstructorsModal()">
        Edit Instructors
      </button>
      <button class="btn btn-outline-danger btn-sm"
              *ngIf="!event.is_cancelled"
              (click)="openCancelEventModal()">
        Cancel Event
      </button>
      <button class="btn btn-danger btn-sm disabled"
              disabled
              *ngIf="event.is_cancelled">
        Event Cancelled
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <ng-container *ngIf="event.roster_name">
        Roster: <b>{{ event.roster_name }}</b>
        <br>
      </ng-container>
      Location: <b>{{ event.location_name }}</b>
      <br>
      Time Zone: <b>{{ getTimeZoneDisplayName(event.time_zone) }}</b>
      <br>
      <span placement="bottom"
            [ngbTooltip]="instructorsManuallyEdited(event) ? 'This event\'s instructors have been manually edited, and do not reflect the schedule\'s instructors.' : ''">
        Instructor{{ event.instructors.length > 1 ? 's' : '' }}:
        <b>
          <span *ngFor="let instructor of event.instructors; let last = last;">
            {{ instructor.first_name }} {{ instructor.last_name }}{{ instructor.is_sub ? ' (Sub)' : '' }}{{ last ? '' : ',' }}
          </span>
          <span *ngIf="event.instructors.length === 0" class="text-muted">None</span>
          <span *ngIf="instructorsManuallyEdited(event)">*</span>
        </b>
      </span>
      <br>
      <span placement="bottom"
            [ngbTooltip]="eventFullDueToSecondaryCapacity(event) ? 'Facility capacity or booking limit reached for this event.' : ''">
        Check-Ins / Reservations / Capacity:
        <b>
          {{ event.check_in_count}} / {{ event.reservation_count }} / {{ event.capacity }}
          <span *ngIf="eventFullDueToSecondaryCapacity(event)">*</span>
        </b>
      </span>
      <br>
      <span placement="bottom"
            ngPreserveWhitespaces
            [ngbTooltip]="event.allow_customers_to_join_waitlist ? '' : 'This event does not allow customers to join the waitlist via the Climber App. The waitlist may only be added to by staff members.'">
        Waitlist Count:
        <b>{{ event.waitlist_count }} ({{ event.waitlist_count_pending }} pending)</b>
        <span *ngIf="!event.allow_customers_to_join_waitlist">*</span>
      </span>
      <br>
      <ng-container *ngIf="!event.is_private">
        <ng-container *ngIf="event.schedule_id">
          Schedule:
          <a routerLink="/events/setup/edit/{{ event.event_type_id }}/schedules/{{ event.schedule_id }}">
            <b>
              <ng-container *ngIf="event.schedule_name">{{ event.schedule_name }}</ng-container>
              <ng-container *ngIf="!event.schedule_name">Unnamed Schedule</ng-container>
              (#{{ event.schedule_id }})
            </b>
          </a>
        </ng-container>
        <ng-container *ngIf="event.schedule_exception_id">
          Schedule Exception:
          <a routerLink="/events/setup/edit/{{ event.event_type_id }}/schedule-exceptions/{{ event.schedule_exception_id }}">
            <b>
              <ng-container *ngIf="event.schedule_exception_name">{{ event.schedule_exception_name }}</ng-container>
              <ng-container *ngIf="!event.schedule_exception_name">Unnamed Schedule Exception</ng-container>
              (#{{ event.schedule_exception_id }})
            </b>
          </a>
        </ng-container>
        <b class="text-muted" *ngIf="!event.schedule_id && !event.schedule_exception_id">
          No Schedule
        </b>
        <ng-container *ngIf="(event.event_type_schedule_type === ScheduleType.repeating) && !event.schedule_id && !event.schedule_exception_id && !event.is_cancelled">
          <br>
          <b class="text-danger">
            This event belonged to a schedule which was deleted. Because the event had reservations, it was not cancelled automatically.
          </b>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="event.is_private">
        <b class="text-muted" *ngIf="loadingPrivateEventRequestFormInfo">
          Loading...
        </b>
        <ng-container *ngIf="!loadingPrivateEventRequestFormInfo">
          <b class="text-muted" *ngIf="hasNoPrivateEventRequestForm">
            No Request Form
          </b>
          <ng-container *ngIf="privateEventRequestFormInfo">
            Request Form:
            <a routerLink="/events/scheduled/now/event/{{ privateEventRequestFormInfo.first_event_part_id }}">
              <b>{{ privateEventRequestFormInfo.event_type_name }}</b>
            </a>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <nav class="navbar navbar-expand navbar-light bg-light rounded-border rounded-tight profile-nav mt-3"
       style="padding-left: 8px;padding-right: 0; overflow: hidden;">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link text-nowrap" href="#"
           [class.active]="subList === SubList.participants"
           (click)="selectSubList(SubList.participants);$event.preventDefault();">
          Participants
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link text-nowrap" href="#"
           [class.active]="subList === SubList.waitlist"
           (click)="selectSubList(SubList.waitlist);$event.preventDefault();">
          Waitlist
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link text-nowrap" href="#"
           [class.active]="subList === SubList.notes"
           (click)="selectSubList(SubList.notes);$event.preventDefault();">
          Notes
          <span *ngIf="!loadingEvent">({{ event.num_notes }})</span>
        </a>
      </li>
    </ul>
  </nav>

  <div *ngIf="!loadingEventPartial">

    <app-event-participants-sub-list *ngIf="subList === SubList.participants"
                                     [event]="event"
                                     [resultCallback]="handleSubListResult"
                                     [showNonpaymentCancelledReservations]="showNonpaymentCancelledReservations"
                                     [showNonpaymentCancelledChangeCallback]="handleShowNonpaymentCancelledChange"
                                     [(pendingCheckInReservationPartId)]="pendingCheckInReservationPartId"></app-event-participants-sub-list>

    <ng-container *ngIf="subList === SubList.waitlist">

      <app-event-waitlist-sub-list *ngIf="event.waitlist_scope === EventTypeWaitlistScope.event"
                                   [event]="event"
                                   [resultCallback]="handleSubListResult"></app-event-waitlist-sub-list>

      <p *ngIf="event.waitlist_scope === EventTypeWaitlistScope.eventType"
         class="mt-3">
        This event uses an event type-wide waitlist.
        <a routerLink="/events/scheduled/waitlists/event-type/{{ event.event_type_id }}">Click here to view the waitlist.</a>
      </p>

    </ng-container>

    <app-event-notes-sub-list *ngIf="subList === SubList.notes"
                              [event]="event"
                              [resultCallback]="handleSubListResult"></app-event-notes-sub-list>

  </div>

  <div class="alert alert-info mt-3" *ngIf="loadingEventPartial">
    Loading...
  </div>

  <div class="floating-alert-container">
    <div class="alert alert-dismissible"
         [class.alert-success]="callbackResult.status === CallbackResultStatus.success"
         [class.alert-danger]="callbackResult.status === CallbackResultStatus.error"
         role="alert" *ngIf="callbackResult !== null">
      {{ callbackResult.text }}
      <button type="button" class="close" (click)="callbackResult = null">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>

</div>
